import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  deliveryCreate,
  deliveryDelete,
  deliveryLoadByCountry,
  deliveryUpdate,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(deliveryLoadByCountry.type, send, socket);
  yield takeEvery(deliveryCreate.type, send, socket);
  yield takeEvery(deliveryUpdate.type, send, socket);
  yield takeEvery(deliveryDelete.type, send, socket);
}
